import { cloneDeepObject } from '@/views/website/products/components/description/common/utils.js';
import { getAccordionPrimaryIconSvg } from './raw-html';

const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};

const defaultAccordion = {
  open: true,
  title: 'Accordion Title',
  backgroundColor: '#000000',
  color: '#ffffff',
  icon: {
    type: 'plus-minus', // chevron-down-up, plus-minus, plus-close
    position: 'right', // left, right
    show: true,
  },
};

export const extractAccordionPrimary = htmlString => {
  const doc = parseHtml(htmlString);
  const result = {
    ...cloneDeepObject(defaultAccordion),
  };

  const accordionPrimaryEl = doc.querySelector('[data-attribute="accordion-primary-title"]');

  if (accordionPrimaryEl) {
    result.open = accordionPrimaryEl.getAttribute('data-open') !== 'false';
    result.backgroundColor = accordionPrimaryEl.getAttribute('data-background') || result.backgroundColor;
    result.color = accordionPrimaryEl.getAttribute('data-color') || result.color;
    result.icon.type = accordionPrimaryEl.getAttribute('data-icon-type') || result.icon.type;
    result.icon.position = accordionPrimaryEl.getAttribute('data-icon-position') || result.icon.position;
    result.icon.show = accordionPrimaryEl.getAttribute('data-icon-show') !== 'false';
    const titleEl = accordionPrimaryEl.querySelector('[data-attribute="accordion-title"]');
    if (titleEl) {
      result.title = titleEl.innerHTML.trim() || result.title;
    }
  }

  return result;
};

export const updateAccordionPrimary = (wrapel, updatedData) => {
  const accordionPrimaryEl = wrapel.querySelector('[data-attribute="accordion-primary-title"]');
  if (!accordionPrimaryEl) return wrapel.outerHTML.trim();

  const icon = {
    ...cloneDeepObject(defaultAccordion.icon),
    ...(updatedData.icon || {}),
  };
  const open = !!updatedData.open;

  accordionPrimaryEl.setAttribute('data-open', open ? 'true' : 'false');
  accordionPrimaryEl.setAttribute('data-background', updatedData.backgroundColor);
  accordionPrimaryEl.setAttribute('data-color', updatedData.color);
  accordionPrimaryEl.setAttribute('data-icon-type', icon.type);
  accordionPrimaryEl.setAttribute('data-icon-position', icon.position);
  accordionPrimaryEl.setAttribute('data-icon-show', icon.show ? 'true' : 'false');

  accordionPrimaryEl.style.backgroundColor = updatedData.backgroundColor;
  accordionPrimaryEl.style.color = updatedData.color;
  accordionPrimaryEl.style.display = 'flex';
  accordionPrimaryEl.style.alignItems = 'center';
  accordionPrimaryEl.style.gap = '8px';
  accordionPrimaryEl.style.justifyContent = 'center';
  accordionPrimaryEl.style.flexDirection = icon.position === 'left' ? 'row-reverse' : 'row';

  const titleEl = accordionPrimaryEl.querySelector('[data-attribute="accordion-title"]');
  if (titleEl) {
    titleEl.innerHTML = updatedData.title;
  }

  const iconEl = accordionPrimaryEl.querySelector('[data-attribute="accordion-icon"]');
  if (iconEl) {
    iconEl.innerHTML = getAccordionPrimaryIconSvg(icon.type, open);
  }

  return wrapel.outerHTML.trim();
};
